(() => {
  if (window.PWGCartQuestionAssetLoaded) return;
  window.PWGCartQuestionAssetLoaded = true;

  const WRAPPER_SELECTOR = '.cart-recipient-options[id$="-RecipientOptions"]';
  const DRAFT_KEY = 'pwgCartQuestionDraft_v1';
  const RESCAN_DELAYS = [0, 150, 500, 1200, 2500];

  if (!window.PWGSlideToggle) {
    window.PWGSlideToggle = {
      ensureShell(element) {
        if (!element) return null;

        let shell = element.parentElement;
        if (shell && shell.classList.contains('pwg-slide-shell')) return shell;

        shell = document.createElement('div');
        shell.className = 'pwg-slide-shell';
        shell.style.display = 'none';
        shell.style.overflow = 'hidden';
        shell.style.height = '0px';
        shell.style.width = '100%';
        shell.style.boxSizing = 'border-box';

        const computed = window.getComputedStyle(element);
        shell.dataset.originalDisplay = computed.display === 'none' ? '' : computed.display || '';
        shell.dataset.originalMarginTop = computed.marginTop || '';
        shell.dataset.originalMarginBottom = computed.marginBottom || '';

        element.style.marginTop = '0';
        element.style.marginBottom = '0';
        element.style.display = shell.dataset.originalDisplay || '';

        element.parentNode.insertBefore(shell, element);
        shell.appendChild(element);
        return shell;
      },

      getExpandedHeight(shell) {
        if (!shell) return 0;
        return Math.ceil(shell.scrollHeight);
      },

      setExpanded(element, expanded, options = {}) {
        if (!element) return;

        const settings = {
          animate: true,
          duration: 300,
          easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)',
          onStart: null,
          onComplete: null,
          ...options,
        };

        const shell = this.ensureShell(element);
        if (!shell) return;

        if (typeof shell.__pwgStopAnimation === 'function') {
          shell.__pwgStopAnimation();
        }

        const complete = () => {
          shell.style.overflow = '';
          shell.style.transition = '';
          shell.style.willChange = '';
          shell.style.height = expanded ? '' : '0px';
          shell.style.display = expanded ? '' : 'none';
          shell.__pwgStopAnimation = null;

          if (typeof settings.onComplete === 'function') {
            settings.onComplete();
          }
        };

        if (!settings.animate) {
          if (typeof settings.onStart === 'function') settings.onStart();
          shell.style.display = expanded ? '' : 'none';
          shell.style.height = expanded ? '' : '0px';
          complete();
          return;
        }

        if (typeof settings.onStart === 'function') settings.onStart();

        shell.style.display = '';
        shell.style.overflow = 'hidden';
        shell.style.willChange = 'height';

        const startHeight = Math.ceil(shell.getBoundingClientRect().height);
        shell.style.height = `${startHeight}px`;
        shell.offsetHeight;

        let endHeight = 0;
        if (expanded) {
          shell.style.height = 'auto';
          endHeight = this.getExpandedHeight(shell);
          shell.style.height = `${startHeight}px`;
        } else {
          endHeight = 0;
        }

        if (startHeight === endHeight) {
          complete();
          return;
        }

        shell.style.transition = `height ${settings.duration}ms ${settings.easing}`;

        const onEnd = (event) => {
          if (event.target !== shell || event.propertyName !== 'height') return;
          shell.removeEventListener('transitionend', onEnd);
          complete();
        };

        shell.addEventListener('transitionend', onEnd);
        shell.__pwgStopAnimation = () => {
          shell.removeEventListener('transitionend', onEnd);
          const currentHeight = Math.ceil(shell.getBoundingClientRect().height);
          shell.style.transition = '';
          shell.style.height = `${currentHeight}px`;
        };

        requestAnimationFrame(() => {
          shell.style.height = `${endHeight}px`;
        });
      },
    };
  }

  function getWrappers(root = document) {
    if (!root) return [];
    if (root.matches && root.matches(WRAPPER_SELECTOR)) return [root];
    return Array.from(root.querySelectorAll(WRAPPER_SELECTOR));
  }

  function getContext(wrapper) {
    const prefix = wrapper.id.replace(/-RecipientOptions$/, '');
    const formId = wrapper.dataset.formId || 'cart';
    const noteId = wrapper.dataset.noteId || '';

    const yes = wrapper.querySelector(`[id="${prefix}-ShipYes"]`);
    const no = wrapper.querySelector(`[id="${prefix}-ShipNo"]`);
    const fields = wrapper.querySelector(`[id="${prefix}-GiftFields"]`);

    const sender = wrapper.querySelector(`[id="${prefix}-SenderName"]`);
    const recipient = wrapper.querySelector(`[id="${prefix}-RecipientName"]`);
    const message = wrapper.querySelector(`[id="${prefix}-GiftMessage"]`);
    const count = wrapper.querySelector(`[id="${prefix}-CharCount"]`);

    const shipError = wrapper.querySelector(`[id="${prefix}-ShipError"]`);
    const giftError = wrapper.querySelector(`[id="${prefix}-GiftError"]`);

    const form = document.getElementById(formId);

    let noteEl = null;
    if (noteId) noteEl = document.getElementById(noteId);
    if (!noteEl && form) noteEl = form.querySelector('textarea[name="note"]');

    return {
      wrapper,
      prefix,
      formId,
      noteId,
      yes,
      no,
      fields,
      sender,
      recipient,
      message,
      count,
      shipError,
      giftError,
      form,
      noteEl,
    };
  }

  function getSearchRoot(ctx) {
    if (!ctx || !ctx.wrapper) return document;
    return (
      ctx.wrapper.closest('#main-cart-footer') ||
      ctx.wrapper.closest('.cart__footer-wrapper') ||
      ctx.wrapper.closest('main') ||
      document
    );
  }

  function shipChoiceSelected(ctx) {
    return !!((ctx.yes && ctx.yes.checked) || (ctx.no && ctx.no.checked));
  }

  function giftNamesValidIfNeeded(ctx) {
    const yesChecked = !!(ctx.yes && ctx.yes.checked);
    if (!yesChecked) return true;

    const s = ((ctx.sender && ctx.sender.value) || '').trim();
    const r = ((ctx.recipient && ctx.recipient.value) || '').trim();

    return !!(s && r);
  }

  function validForCheckout(ctx) {
    return shipChoiceSelected(ctx) && giftNamesValidIfNeeded(ctx);
  }

  function showErrorsIfNeeded(ctx) {
    if (ctx.shipError) ctx.shipError.style.display = 'none';
    if (ctx.giftError) ctx.giftError.style.display = 'none';

    if (!shipChoiceSelected(ctx)) {
      if (ctx.shipError) ctx.shipError.style.display = 'block';
      return false;
    }

    if (!giftNamesValidIfNeeded(ctx)) {
      if (ctx.giftError) ctx.giftError.style.display = 'block';
      return false;
    }

    return true;
  }

  function scrollToQuestions(ctx) {
    if (!ctx.wrapper) return;

    const headerOffset = 140;
    const wrapperTop = ctx.wrapper.getBoundingClientRect().top + window.pageYOffset;
    const targetTop = Math.max(wrapperTop - headerOffset, 0);

    window.scrollTo({
      top: targetTop,
      behavior: 'smooth',
    });
  }

  function focusFirstProblem(ctx) {
    const focusOptions = { preventScroll: true };

    if (!shipChoiceSelected(ctx)) {
      if (ctx.yes) ctx.yes.focus(focusOptions);
      return;
    }

    if (ctx.yes && ctx.yes.checked) {
      const s = ((ctx.sender && ctx.sender.value) || '').trim();
      const r = ((ctx.recipient && ctx.recipient.value) || '').trim();

      if (!s && ctx.sender) {
        ctx.sender.focus(focusOptions);
        return;
      }

      if (!r && ctx.recipient) {
        ctx.recipient.focus(focusOptions);
      }
    }
  }

  function setCount(ctx) {
    if (!ctx.message || !ctx.count) return;
    ctx.count.textContent = String((ctx.message.value || '').length);
  }

  function getCheckoutButtons(ctx) {
    const root = getSearchRoot(ctx);
    let buttons = [];

    buttons = buttons.concat(
      Array.from(root.querySelectorAll(`button[name="checkout"][form="${ctx.formId}"]`))
    );

    if (ctx.form) {
      buttons = buttons.concat(Array.from(ctx.form.querySelectorAll('button[name="checkout"]')));
    }

    buttons = buttons.concat(
      Array.from(root.querySelectorAll(`button[type="submit"][name="checkout"][form="${ctx.formId}"]`))
    );

    return Array.from(new Set(buttons)).filter(Boolean);
  }

  function findExpressContainers(ctx) {
    const root = getSearchRoot(ctx);
    const container =
      root.querySelector('.cart__dynamic-checkout-buttons.additional-checkout-buttons') ||
      root.querySelector('.cart__dynamic-checkout-buttons') ||
      root.querySelector('.additional-checkout-buttons');

    return container ? [container] : [];
  }

  function ensureOverlay(container, ctx) {
    if (!container) return null;

    const style = window.getComputedStyle(container);
    if (style.position === 'static') container.style.position = 'relative';

    let overlay = container.querySelector('.pwg-express-overlay');

    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'pwg-express-overlay';
      overlay.style.position = 'absolute';
      overlay.style.inset = '0';
      overlay.style.zIndex = '9999';
      overlay.style.background = 'transparent';
      overlay.style.cursor = 'not-allowed';

      overlay.addEventListener(
        'click',
        (e) => {
          if (validForCheckout(ctx)) return;

          e.preventDefault();
          e.stopPropagation();
          showErrorsIfNeeded(ctx);
          scrollToQuestions(ctx);
          focusFirstProblem(ctx);
        },
        true
      );

      container.appendChild(overlay);
    }

    return overlay;
  }

  function setExpressLocked(ctx, locked) {
    const containers = findExpressContainers(ctx);

    containers.forEach((container) => {
      if (locked) {
        const overlay = ensureOverlay(container, ctx);
        if (!overlay) return;

        overlay.style.display = 'block';
        container.style.opacity = '0.55';
        container.style.pointerEvents = 'auto';
        container.setAttribute('aria-disabled', 'true');
      } else {
        container.querySelectorAll('.pwg-express-overlay').forEach((overlay) => overlay.remove());
        container.style.opacity = '';
        container.style.pointerEvents = '';
        container.removeAttribute('aria-disabled');
      }
    });
  }

  function buildNoteSummary(ctx) {
    const isDirectShip = ctx.yes && ctx.yes.checked;
    const s = ((ctx.sender && ctx.sender.value) || '').trim();
    const r = ((ctx.recipient && ctx.recipient.value) || '').trim();
    const m = ((ctx.message && ctx.message.value) || '').trim();

    if (!isDirectShip) return '';

    const lines = [];
    lines.push('Is this Shipping Directly to the Recipient?: Yes');
    if (s) lines.push(`Senders Name: ${s}`);
    if (r) lines.push(`Recipients Name: ${r}`);
    if (m) lines.push(`Gift Message: ${m}`);

    return lines.join('\n');
  }

  function mirrorToNote(ctx, isYes) {
    if (!ctx.noteEl) return;

    const existing = (ctx.noteEl.value || '').trim();
    const looksLikeOurs =
      /^(Is this Shipping Directly to the Recipient\?:|Senders Name:|Recipients Name:|Gift Message:)/.test(existing);

    if (isYes) {
      ctx.noteEl.value = buildNoteSummary(ctx);
    } else if (looksLikeOurs) {
      ctx.noteEl.value = '';
    }
  }

  function saveDraftToSession(ctx) {
    try {
      if (!window.sessionStorage) return;

      const draft = {
        ship: ctx.yes && ctx.yes.checked ? 'Yes' : ctx.no && ctx.no.checked ? 'No' : '',
        sender: ctx.sender ? ctx.sender.value : '',
        recipient: ctx.recipient ? ctx.recipient.value : '',
        message: ctx.message ? ctx.message.value : '',
      };

      if (!draft.ship) {
        clearDraftFromSession();
        return;
      }

      sessionStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
    } catch (e) {}
  }

  function restoreDraftFromSession(ctx) {
    try {
      if (!window.sessionStorage) return;

      const raw = sessionStorage.getItem(DRAFT_KEY);
      if (!raw) return;

      const draft = JSON.parse(raw);
      if (!draft || !draft.ship) {
        clearDraftFromSession();
        return;
      }

      if (ctx.yes) ctx.yes.checked = draft.ship === 'Yes';
      if (ctx.no) ctx.no.checked = draft.ship === 'No';

      if (draft.ship === 'Yes') {
        if (ctx.sender) ctx.sender.value = draft.sender || '';
        if (ctx.recipient) ctx.recipient.value = draft.recipient || '';
        if (ctx.message) ctx.message.value = draft.message || '';
      } else {
        if (ctx.sender) ctx.sender.value = '';
        if (ctx.recipient) ctx.recipient.value = '';
        if (ctx.message) ctx.message.value = '';
      }
    } catch (e) {}
  }

  function clearDraftFromSession() {
    try {
      if (!window.sessionStorage) return;
      sessionStorage.removeItem(DRAFT_KEY);
    } catch (e) {}
  }

  function setCheckoutState(ctx) {
    const ok = validForCheckout(ctx);
    setExpressLocked(ctx, !ok);
  }

  function toggleUI(ctx) {
    const yesChecked = !!(ctx.yes && ctx.yes.checked);
    const noChecked = !!(ctx.no && ctx.no.checked);

    if (ctx.fields) {
      const animate = ctx.fields.dataset.pwgSlideInit === '1';
      window.PWGSlideToggle.setExpanded(ctx.fields, yesChecked, { animate, duration: 220 });
      ctx.fields.dataset.pwgSlideInit = '1';
    }

    if (ctx.sender) ctx.sender.required = yesChecked;
    if (ctx.recipient) ctx.recipient.required = yesChecked;

    if (ctx.shipError) ctx.shipError.style.display = 'none';
    if (ctx.giftError) ctx.giftError.style.display = 'none';

    if (noChecked) {
      if (ctx.sender) ctx.sender.value = '';
      if (ctx.recipient) ctx.recipient.value = '';
      if (ctx.message) ctx.message.value = '';
      setCount(ctx);
    }

    if (yesChecked) mirrorToNote(ctx, true);
    if (noChecked) mirrorToNote(ctx, false);

    saveDraftToSession(ctx);
    setCheckoutState(ctx);
  }

  function bindCheckoutClickGuards(ctx) {
    getCheckoutButtons(ctx).forEach((btn) => {
      if (!btn || btn.dataset.pwgCartQuestionBound === '1') return;
      btn.dataset.pwgCartQuestionBound = '1';

      btn.addEventListener(
        'click',
        (e) => {
          if (validForCheckout(ctx)) return;

          e.preventDefault();
          e.stopPropagation();
          showErrorsIfNeeded(ctx);
          scrollToQuestions(ctx);
          focusFirstProblem(ctx);
          setCheckoutState(ctx);
        },
        true
      );
    });
  }

  function bindFormSubmitGuard(ctx) {
    if (!ctx.form || ctx.form.dataset.pwgCartQuestionSubmitBound === '1') {
      return;
    }

    ctx.form.dataset.pwgCartQuestionSubmitBound = '1';

    ctx.form.addEventListener(
      'submit',
      (e) => {
        if (validForCheckout(ctx)) return;

        e.preventDefault();
        showErrorsIfNeeded(ctx);
        scrollToQuestions(ctx);
        focusFirstProblem(ctx);
        setCheckoutState(ctx);
      },
      true
    );
  }

  function scheduleCheckoutRescans(ctx) {
    if (!ctx || !ctx.wrapper) return;

    if (Array.isArray(ctx.wrapper.__pwgRescanTimers)) {
      ctx.wrapper.__pwgRescanTimers.forEach((timerId) => window.clearTimeout(timerId));
    }

    ctx.wrapper.__pwgRescanTimers = RESCAN_DELAYS.map((delay) =>
      window.setTimeout(() => {
        if (!document.body.contains(ctx.wrapper)) return;
        bindCheckoutClickGuards(ctx);
        setCheckoutState(ctx);
      }, delay)
    );
  }

  function initWrapper(wrapper) {
    if (!wrapper) return;

    const existingApi = wrapper.__pwgCartQuestionApi;
    if (existingApi) {
      existingApi.bindCheckoutClickGuards();
      existingApi.setCheckoutState();
      existingApi.setCount();
      existingApi.scheduleCheckoutRescans();
      return;
    }

    const ctx = getContext(wrapper);
    if (!ctx.yes || !ctx.no) return;

    const api = {
      setCheckoutState: () => setCheckoutState(ctx),
      bindCheckoutClickGuards: () => bindCheckoutClickGuards(ctx),
      setCount: () => setCount(ctx),
      toggleUI: () => toggleUI(ctx),
      scheduleCheckoutRescans: () => scheduleCheckoutRescans(ctx),
    };

    wrapper.__pwgCartQuestionApi = api;

    bindFormSubmitGuard(ctx);

    [ctx.sender, ctx.recipient].forEach((el) => {
      if (!el) return;

      el.addEventListener('input', () => {
        if (ctx.giftError) ctx.giftError.style.display = 'none';
        saveDraftToSession(ctx);
        setCheckoutState(ctx);

        if (ctx.yes && ctx.yes.checked) {
          mirrorToNote(ctx, true);
        }
      });
    });

    if (ctx.message) {
      ctx.message.addEventListener('input', () => {
        setCount(ctx);
        saveDraftToSession(ctx);

        if (ctx.yes && ctx.yes.checked) {
          mirrorToNote(ctx, true);
        }
      });
    }

    if (ctx.yes) {
      ctx.yes.addEventListener('change', () => toggleUI(ctx));
    }

    if (ctx.no) {
      ctx.no.addEventListener('change', () => toggleUI(ctx));
    }

    restoreDraftFromSession(ctx);
    setCount(ctx);
    toggleUI(ctx);
    bindCheckoutClickGuards(ctx);
    scheduleCheckoutRescans(ctx);
  }

  window.PWGCartQuestionInit = function (root = document) {
    getWrappers(root).forEach((wrapper) => initWrapper(wrapper));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.PWGCartQuestionInit(document);
    });
  } else {
    window.PWGCartQuestionInit(document);
  }
})();